export default __webpack_public_path__ + "images/XU.84bd17d.png";